import React from 'react';

import ModalContainer from '@components/modals/ModalContainer';

const GoToMeasurementModal = ({ title, onSubmit, onClose }) => {
	return (
		<ModalContainer onCloseModal={onClose}>
			<div className="common-popup arrange-category-modal shadow-24dp">
				<div className="common-popup-body">
					<p>{title}</p>
				</div>

				<div className="modal-footer">
					<div className="footer-buttons text-right">
						<button className="button gray-outline size32 ml-2" onClick={onClose}>
							Cancel
						</button>
						<button className="button size32 ml-2" onClick={onSubmit}>
							Go to the measurement chart
						</button>
					</div>
				</div>
			</div>
		</ModalContainer>
	);
};

export default GoToMeasurementModal;
